<template>
    <moe-page>
        <moe-top></moe-top>
        <div class="exam_start flex flexcolumn Flexalign">
            <div class="exma_title flex Flexalign mt-30">
                <div class="flex Flexalign cursor_pointer" @click="goOnlineLearning">
                    <!-- < -->
                    <el-icon>
                        <ArrowLeft />
                    </el-icon>
                    <div class="ml-5">返回</div>
                </div>
                <div class="exam_result ml-10 flex Flexalign">
                    |
                    <div class="ml-10">测评结果</div>
                </div>
            </div>
            <div class="my-30 exma_title exam_info">
                <div class="organization_info cursor_pointer flex Flexalign">
                    <el-image class="gjkc_index_logo" :src="iconPath('gjkc_index_logo.png')"></el-image>
                    <div class="ml-15">
                        {{
                            courseTypeList.filter((item) => item.value == selectCourseType)[0]?.label
                        }}
                    </div>
                </div>
                <div class="empty_box flex flexcolumn Flexalign">
                    <el-image class="moe_empty_bg_img" :src="imgPath('exam_finish_empty_bg.png')"></el-image>
                    <div class="empty_text">试卷批阅中，预计3-5分钟完成。点击下方刷新按钮查看进度，批阅完成将自动进入结果分析页</div>
                    <div class="btn cursor_pointer mt-20" @click="refreshResult">刷新</div>
                </div>
            </div>
        </div>
    </moe-page>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5ExamFinish",
    components: {},
    computed: {
        ...mapState({
            selectCourseType: (state) => state.user.selectCourseType,
            courseTypeList: (state) => state.filter.courseTypeList,
            currentExamCourseId: (state) => state.learning.currentExamCourseId,
        }),
    },
    watch: {
        selectCourseType: {
            handler(value) {
                this.gjkcTypeValue = value;
            },
            deep: true,
            immediate: true,
        },
    },

    data() {
        return {
            gjkcTypeValue: "",
            examInfo: {
                name: "练习卷3",
                desc: "测试描述测试描述测试描述测试描述测试描述",
                accuracyRate: 60,
                score: 60,
                totalScore: 100,
                startTime: "2025-09-01 11:13:16",
                endTime: "2025-09-01 11:13:16",
                useTime: "07:13:16",
            },
            recordId: {},
            courseId: "",
            testPaperType: '',
            testPaperInfo: {}
        };
    },

    mounted() {
        this.recordId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).recordId;
        this.courseId = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).courseId;
        this.testPaperType = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).testPaperType;
    },

    methods: {
        refreshResult() {
            this.$Api.testPaper.getTestPaperReportStatus(this.recordId).then(res => {
                if (res.data.data) {
                  this.href("/examFinish", { recordId: this.recordId, testPaperType: this.testPaperType });
                } else {
                  this.$Dialog.toast("报告正在生成中，请稍后查询", { type: 'warning' });
                }
            }).catch(() => { })
            // this.href("/examAnalysis", { recordId: this.recordId, testPaperType: this.testPaperType });
        }
    },
};
</script>

<style lang="scss" scoped>
.exam_start {
    width: 100%;
    background: #f3f3f3;

    .exma_title {
        width: $pageMainWidth;
        color: rgba(144, 144, 144, 1);

        .exam_result {
            color: rgba(48, 48, 48, 1);
        }
    }

    .exam_info {
        min-height: 774px;
        background: #ffffff;
        border-radius: 16px;

        .organization_info {
            height: 90px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            padding-left: 25px;
            color: RGBA(17, 17, 17, 1);
            box-sizing: border-box;
            font-family: monospace;
            font-weight: bold;
            font-size: 18px;

            .gjkc_index_logo {
                width: 50px;
                height: 50px;
            }
        }
    }

    .grade_analysis {
        .grade_title {
            font-size: 20px;
            color: #303030;
            font-weight: 500;
        }

        .exam_result {
            .exam_name {
                font-weight: 500;
                font-size: 18px;
                color: #111111;
            }

            .exam_desc {
                font-size: 14px;
                color: #909090;
            }

            .split_line {
                width: 80%;
                height: 1px;
                background: rgba(0, 0, 0, 0.1);
            }

            .exam_response {
                width: 75%;

                .exam_response_one {
                    font-size: 16px;
                    color: #909090;

                    .response_value {
                        color: #303030;
                    }
                }
            }

            .exam_result_box {
                width: 80%;

                .exam_result_one {
                    width: 45%;
                    height: 60px;
                    background: #FAFAFA;
                    border-radius: 11px;
                    font-size: 14px;
                    color: #303030;

                    .exam_detail_icon {
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }

    .empty_box {
        min-height: 600px;
        text-align: center;
        font-size: 15px;
        color: #606060;

        .moe_empty_bg_img {
            width: 313px;
            height: 260px;
            margin-top: 120px;
        }
    }

    .btn {
        width: 160px;
        height: 48px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 30px;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
    }
}
</style>
